import axios from 'axios'
import qs from 'qs'

let instance = axios.create({
  timeout: 1000 * 60,
  baseURL: ''
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers['loginaware'] = true
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if (response.data) {
    return Promise.resolve(response.data)
  } else {
    return Promise.reject(response)
  }
}, function (error) {
  // 对响应错误做点什么
  if (error.response) {
  }
  return Promise.reject(error)
});

/**
 * 公共获取接口数据方法
 * url: 接口路径
 * data ：参数对象
 * type ：请求方式
 * contentType ：请求头格式
 */
export function fetchData(url, data, type, contentType) {
  const config = {};
  config.method = type || 'post';

  if (type === 'get') {
    config.url = url + '?r=' + Math.random() * 1000;
    config.params = data;
  } else {
    config.url = url;
    config.data = contentType == 'application/json' ? data : qs.stringify(data)
  }
  return instance(config)

}